module.exports = __webpack_public_path__ + "0aec2669e2d88d4eebb82548e7bcc604.pdf";